"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateAddressData = exports.addressFormRules = exports.addressFieldMapping = exports.addressSchema = void 0;
const converters_1 = require("../converters");
const libphonenumber_js_1 = __importDefault(require("libphonenumber-js"));
exports.addressSchema = {
    fields: {
        street_line1: {
            required: true,
            maxLength: 100,
        },
        street_line2: {
            maxLength: 100,
        },
        street_line3: {
            maxLength: 100,
        },
        city: {
            required: true,
            maxLength: 50,
        },
        state_code: {
            required: true,
            maxLength: 20,
        },
        postal_code: {
            maxLength: 20,
        },
        zip_code: {
            required: true,
            maxLength: 20,
        },
        community_name: {
            maxLength: 50,
        },
        manager_first_name: {
            maxLength: 50,
        },
        manager_last_name: {
            maxLength: 50,
        },
        manager_phone_number: {
            custom: {
                validate: (value) => {
                    if (!value)
                        return true; // Allow empty values, let required validation handle it
                    try {
                        // Clean the phone number by removing all non-digit characters except +
                        const cleanedNumber = value.replace(/[^\d+]/g, '');
                        // Parse and validate the phone number (default to US for compatibility)
                        const phoneNumber = (0, libphonenumber_js_1.default)(cleanedNumber);
                        // Basic validation
                        if (!phoneNumber?.isValid())
                            return false;
                        // Check if country code is required
                        if (!phoneNumber?.countryCallingCode)
                            return false;
                        return true;
                    }
                    catch (_error) {
                        return false;
                    }
                },
                message: 'validation.invalidPhone',
            },
            maxLength: 20, // Allows for country code, spaces, and phone number
        },
        manager_fax_number: {
            minLength: 7,
            maxLength: 10,
        },
        manager_email: {
            email: true,
        },
        move_in_date: {},
        move_out_date: {},
        monthly_payment_amount: {
            min: 0,
        },
        payment_recipient: {
            maxLength: 50,
        },
        address_type_id: {},
        ownership_status: {},
        residence_type: {},
        leaving_reason: {},
    },
    messages: {
        street_line1: {
            required: 'validation.fieldRequired',
            maxLength: 'validation.maxLength|100',
        },
        street_line2: {
            maxLength: 'validation.maxLength|100',
        },
        street_line3: {
            maxLength: 'validation.maxLength|100',
        },
        city: {
            required: 'validation.fieldRequired',
            maxLength: 'validation.maxLength|50',
        },
        state_code: {
            required: 'validation.fieldRequired',
            maxLength: 'validation.maxLength|20',
        },
        zip_code: {
            required: 'validation.fieldRequired',
            maxLength: 'validation.maxLength|20',
        },
        community_name: {
            maxLength: 'validation.maxLength|50',
        },
        manager_first_name: {
            maxLength: 'validation.maxLength|50',
        },
        manager_last_name: {
            maxLength: 'validation.maxLength|50',
        },
        manager_phone_number: {
            maxLength: 'validation.maxLength|20',
        },
        manager_fax_number: {
            minLength: 'validation.minLength|7',
            maxLength: 'validation.maxLength|10',
        },
        manager_email: {
            email: 'validation.invalidManagerEmail',
        },
        monthly_payment_amount: {
            min: 'validation.min|0',
        },
        payment_recipient: {
            maxLength: 'validation.maxLength|50',
        },
    },
};
// Field mapping between DTO naming and UI naming
exports.addressFieldMapping = {
    street_line1: 'streetLine1',
    street_line2: 'streetLine2',
    street_line3: 'streetLine3',
    city: 'city',
    state_code: 'stateCode',
    zip_code: 'zipCode',
    community_name: 'communityName',
    manager_first_name: 'managerFirstName',
    manager_last_name: 'managerLastName',
    manager_phone_number: 'managerPhoneNumber',
    manager_fax_number: 'managerFaxNumber',
    manager_email: 'managerEmail',
    move_in_date: 'moveInDate',
    move_out_date: 'moveOutDate',
    monthly_payment_amount: 'monthlyPaymentAmount',
    payment_recipient: 'paymentRecipient',
    ownership_status: 'ownershipStatus',
    residence_type: 'residentType',
    leaving_reason: 'reasonForLeaving',
};
// 🚀 Pre-computed validations for performance
exports.addressFormRules = (0, converters_1.toReactHookForm)(exports.addressSchema, exports.addressFieldMapping);
exports.validateAddressData = (0, converters_1.createValidator)(exports.addressSchema);
